import React, { useEffect, useContext } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import { LoadingContext } from '../App'

const NotFound = () => {
    const { setIsPageReady } = useContext(LoadingContext);

    useEffect(() => {
        setIsPageReady(true);
    }, [setIsPageReady]);

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#000', // Assuming dark theme based on other files
            color: '#fff',
            textAlign: 'center',
            padding: '2rem'
        }}>
            <Helmet>
                <title>Page Not Found - Sacesta</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <h1 style={{ fontSize: '4rem', marginBottom: '1rem', background: 'linear-gradient(to right, #fff, #666)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>404</h1>
            <h2 style={{ fontSize: '2rem', marginBottom: '1.5rem', fontWeight: '300' }}>Page Not Found</h2>
            <p style={{ maxWidth: '600px', marginBottom: '2rem', color: '#888', lineHeight: '1.6' }}>
                This page is currently under construction. Please visit again soon.
            </p>
            <Link to="/" style={{
                padding: '12px 30px',
                backgroundColor: '#fff',
                color: '#000',
                textDecoration: 'none',
                borderRadius: '30px',
                fontWeight: 'bold',
                fontSize: '0.9rem',
                transition: 'transform 0.2s',
                display: 'inline-block'
            }}>
                Back to Home
            </Link>
        </div>
    )
}

export default NotFound
